  (function() {
    // ─── Sidebar Collapse Toggle ───
    // Runs FIRST and fully guarded: this used to be the last block in this
    // (very long) IIFE, so any JS error earlier in the file silently killed
    // the tab's click handler — the pop-out tab appeared but never responded.
    try { (function() {
      var collapseTab = document.getElementById('sidebar-collapse-tab');
      var layoutWrapper = document.querySelector('.collection-layout-with-sidebar');
      var sidebarCol = document.getElementById('collection-sidebar-column');
      var sidebarWrapper = document.getElementById('collection-sidebar-wrapper');

      if (!collapseTab || !layoutWrapper || !sidebarCol) return;

      // Restore saved state (default: open)
      var isCollapsed = false;
      try {
        isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true';
      } catch (e) {}

      function applyCollapseState(collapsed, animate) {
        if (!animate) {
          layoutWrapper.style.transition = 'none';
          sidebarCol.style.transition = 'none';
          if (sidebarWrapper) sidebarWrapper.style.transition = 'none';
        }

        if (collapsed) {
          layoutWrapper.classList.add('sidebar-collapsed');
          collapseTab.classList.add('is-collapsed');
          collapseTab.setAttribute('aria-expanded', 'false');
          collapseTab.setAttribute('aria-label', 'Expand sidebar');
        } else {
          layoutWrapper.classList.remove('sidebar-collapsed');
          collapseTab.classList.remove('is-collapsed');
          collapseTab.setAttribute('aria-expanded', 'true');
          collapseTab.setAttribute('aria-label', 'Collapse sidebar');
        }

        if (!animate) {
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              layoutWrapper.style.transition = '';
              sidebarCol.style.transition = '';
              if (sidebarWrapper) sidebarWrapper.style.transition = '';
            });
          });
        }
      }

      // Apply initial state without animation
      applyCollapseState(isCollapsed, false);

      // Click handler
      collapseTab.addEventListener('click', function() {
        isCollapsed = !isCollapsed;

        // If filters are active and we're collapsing, close filters first
        if (isCollapsed && sidebarCol.classList.contains('filters-active')) {
          sidebarCol.classList.remove('filters-active');
        }

        applyCollapseState(isCollapsed, true);

        try {
          localStorage.setItem('sidebarCollapsed', isCollapsed);
        } catch (e) {}
      });

      // Expose for external use
      window.isSidebarCollapsed = function() { return isCollapsed; };
    })(); } catch(e) { console.error('[Collection] Sidebar collapse init:', e); }

    // ─── Hero title letter-by-letter flip reveal ───
    try { (() => {
      const heroTitle = document.querySelector('.collections-hero__title-text');
      if (heroTitle) {
        const text = heroTitle.textContent;
        const underline = heroTitle.parentElement.querySelector('.collections-hero__title-underline');
        heroTitle.textContent = '';
        let charIndex = 0;
        for (let i = 0; i < text.length; i++) {
          const span = document.createElement('span');
          if (text[i] === ' ') {
            span.className = 'hero-letter hero-letter--space';
            span.innerHTML = '&nbsp;';
          } else {
            span.className = 'hero-letter';
            span.textContent = text[i];
            span.style.animationDelay = `${charIndex * 0.06}s`;
            charIndex++;
          }
          heroTitle.appendChild(span);
        }
        // Delay underline until after all letters finish
        const totalDelay = (charIndex * 0.06) + 0.3;
        if (underline) {
          underline.style.animationDelay = `${totalDelay}s`;
        }
        // Fade in description box after underline starts
        const descBlock = document.querySelector('.collections-hero__desc-block');
        if (descBlock) {
          descBlock.style.animationDelay = `${totalDelay + 0.4}s`;
        }
      }
    })(); } catch(e) { console.error('[Collection] Hero init:', e); }

    // Smooth scroll + fade-in on page load (for menu navigation via #collection-content)
    // Pauses on hero banner so users can see the title animation, then scrolls down
    try { (() => {
      if (!window.__collectionHashNav) return;
      const target = document.getElementById('collection-content');
      const productsGrid = document.querySelector('.collection-products');
      if (productsGrid) {
        productsGrid.style.opacity = '0';
        productsGrid.style.transition = 'opacity 0.5s ease';
      }
      if (!target) return;

      // Allow user to interrupt auto-scroll by scrolling manually
      let userHasScrolled = false;
      const scrollListener = () => { userHasScrolled = true; };
      window.addEventListener('scroll', scrollListener, { passive: true });

      setTimeout(() => {
        window.removeEventListener('scroll', scrollListener);
        if (userHasScrolled && window.scrollY > 50) {
          if (productsGrid) productsGrid.style.opacity = '1';
          return;
        }
        if (window.lenisInstance) {
          window.lenisInstance.scrollTo(target, { offset: 0, duration: 1.2 });
        } else {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (productsGrid) {
          productsGrid.style.opacity = '1';
        }
      }, 4320);
    })(); } catch(e) { console.error('[Collection] Scroll init:', e); }

    // Instant scroll for pagination — skip hero, jump straight to product grid
    try { (() => {
      if (!window.__collectionPaginationNav) return;
      const target = document.getElementById('collection-content');
      if (!target) return;
      // Use requestAnimationFrame to ensure layout is ready before scrolling
      requestAnimationFrame(() => {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
      });
    })(); } catch(e) { console.error('[Collection] Pagination:', e); }

    // Auto-scroll past hero to product grid on initial page load
    try { (() => {
      const url = new URL(window.location.href);
      const hasHash = window.location.hash && window.location.hash.length > 1;
      const hasPagination = url.searchParams.has('page') || url.searchParams.has('page_info');
      const hasFilters = Array.from(url.searchParams.keys()).some(k =>
        k.startsWith('filter.') || k === 'sort_by'
      );

      if (hasHash || hasPagination || hasFilters || window.__collectionHashNav) return;

      const hero = document.querySelector('.collections-hero--collection');
      if (!hero || hero.offsetParent === null) return;

      let userHasScrolled = false;
      const scrollListener = () => { userHasScrolled = true; };
      window.addEventListener('scroll', scrollListener, { passive: true });

      setTimeout(() => {
        window.removeEventListener('scroll', scrollListener);
        if (userHasScrolled && window.scrollY > 50) return;

        const target = document.getElementById('collection-content');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 4320);
    })(); } catch(e) { console.error('[Collection] Auto-scroll:', e); }

    // Hero Banner Button Distribution
    try { (() => {
      // Ensure filter buttons display in two rows on desktop
      const filterNavs = document.querySelectorAll('.collections-filters--hero');
      const DESKTOP_BREAKPOINT = 769;

      const toPx = (value) => Number.parseFloat(value || '0') || 0;

      const fitFilterButtonText = () => {
        filterNavs.forEach(nav => {
          const buttons = nav.querySelectorAll('.collections-filter-link');
          buttons.forEach(button => {
            const label = button.querySelector('span:not(.collection-icon)');
            if (!label) return;

            const icon = button.querySelector('.collection-icon');
            if (icon) icon.style.display = '';

            const measureAvailable = () => {
              const buttonStyles = getComputedStyle(button);
              const paddingLeft = toPx(buttonStyles.paddingLeft);
              const paddingRight = toPx(buttonStyles.paddingRight);
              const gap = toPx(buttonStyles.columnGap || buttonStyles.gap);

              let available = button.clientWidth - paddingLeft - paddingRight;

              if (icon && icon.getClientRects().length) {
                available -= icon.getBoundingClientRect().width;
                available -= gap;
              }

              return available;
            };

            const fitWithMinFont = (minFontPx) => {
              // Reset any previous fit adjustments before measuring, so responsive CSS can re-apply.
              label.style.fontSize = '';
              label.style.letterSpacing = '';

              const computedLabelStyles = getComputedStyle(label);
              const baseFontPx = toPx(computedLabelStyles.fontSize);
              const baseLetterSpacing = computedLabelStyles.letterSpacing || '';

              const available = measureAvailable();
              if (available <= 0) return true;

              let fontPx = baseFontPx;
              let tightenedTracking = false;

              // A few quick iterations are enough; scrollWidth changes after each tweak.
              for (let i = 0; i < 5; i++) {
                const overflow = label.scrollWidth - available;
                if (overflow <= 0.5) return true;

                // Only now do we start applying inline adjustments.
                if (i === 0) {
                  label.style.fontSize = `${baseFontPx}px`;
                  label.style.letterSpacing = baseLetterSpacing;
                }

                const ratio = available / Math.max(label.scrollWidth, 1);
                if (!tightenedTracking && ratio < 0.92) {
                  label.style.letterSpacing = '0px';
                  tightenedTracking = true;
                }

                const nextFontPx = Math.max(minFontPx, Math.floor(fontPx * ratio));
                if (nextFontPx >= fontPx) {
                  fontPx = Math.max(minFontPx, fontPx - 1);
                } else {
                  fontPx = nextFontPx;
                }
                label.style.fontSize = `${fontPx}px`;

                if (fontPx <= minFontPx) break;
              }

              return (label.scrollWidth - available) <= 0.5;
            };

            const minFontPx = 8;

            if (fitWithMinFont(minFontPx)) return;

            // If we still can't fit, drop the icon to reclaim space and try again.
            if (icon && icon.getClientRects().length) {
              icon.style.display = 'none';
              fitWithMinFont(minFontPx);
            }
          });
        });
      };

      const updateFilterGrid = () => {
        const isDesktop = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`).matches;

        filterNavs.forEach(nav => {
          const buttons = nav.querySelectorAll('.collections-filter-link');
          if (!buttons.length) return;

          if (isDesktop) {
            // Calculate columns for 2 rows on desktop
            const totalButtons = buttons.length;
            const desktopColumns = Math.ceil(totalButtons / 2);

            // Get available width from container, accounting for padding
            const navStyles = getComputedStyle(nav);
            const paddingLeft = parseFloat(navStyles.paddingLeft) || 0;
            const paddingRight = parseFloat(navStyles.paddingRight) || 0;
            const navWidth = nav.offsetWidth - paddingLeft - paddingRight;
            const gap = 16; // 1rem gap
            const minButtonWidth = 100;
            const maxPossibleColumns = Math.floor((navWidth + gap) / (minButtonWidth + gap));

            // Use the smaller of desired columns or max possible to prevent overflow
            const actualColumns = Math.min(desktopColumns, Math.max(1, maxPossibleColumns));

            // Use flexbox for centered rows with visible gaps between buttons
            nav.style.display = 'flex';
            nav.style.flexWrap = 'wrap';
            nav.style.justifyContent = 'center';
            nav.style.alignItems = 'center';
            nav.style.gap = '0.625rem 0.75rem';
            nav.style.gridTemplateColumns = '';
            nav.style.gridTemplateRows = '';

            // Clear any previous explicit positioning
            buttons.forEach((button) => {
              button.style.gridColumn = '';
              button.style.gridRow = '';
            });
          } else {
            // Mobile: reset to auto layout (flex wrap)
            nav.style.gridTemplateColumns = '';
            nav.style.gridTemplateRows = '';
            buttons.forEach(button => {
              button.style.gridColumn = '';
              button.style.gridRow = '';
            });
          }
        });

        // Run after layout changes have taken effect.
        window.requestAnimationFrame(fitFilterButtonText);
      };

      // Run on load and resize with debouncing
      let resizeTimer;
      const debouncedUpdate = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          window.requestAnimationFrame(updateFilterGrid);
        }, 100);
      };

      updateFilterGrid();
      window.requestAnimationFrame(fitFilterButtonText);
      window.addEventListener('resize', debouncedUpdate);
      
      // Also run after fonts load
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          updateFilterGrid();
          window.requestAnimationFrame(fitFilterButtonText);
        });
      }

      // Filter Links Active State
      const filterLinks = document.querySelectorAll('.collections-filter-link');
      if (filterLinks.length > 0) {
        const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
        let hasActiveLink = false;

        filterLinks.forEach(link => {
          const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '') || '/';
          if (!hasActiveLink && linkPath === currentPath) {
            filterLinks.forEach(item => {
              item.classList.remove('is-active');
              item.removeAttribute('aria-current');
            });
            link.classList.add('is-active');
            link.setAttribute('aria-current', 'page');
            hasActiveLink = true;
          }
        });
      }
    })(); } catch(e) { console.error('[Collection] Hero buttons:', e); }

    const sidebar = document.getElementById('collection-filters-sidebar');
    const overlay = document.getElementById('collection-filters-overlay');
    const sidebarColumn = document.getElementById('collection-sidebar-column');
    const toggleBtns = document.querySelectorAll('.collection-filters-toggle');
    const closeBtn = document.querySelector('.collection-filters-sidebar__close');
    const filterToggles = document.querySelectorAll('.collection-filter-section__toggle');

    function isMobile() {
      return window.innerWidth <= 768;
    }

    // Calculate sidebar left offset for edge-to-edge background
    function updateSidebarOffset() {
      if (sidebarColumn && !isMobile()) {
        var rect = sidebarColumn.getBoundingClientRect();
        sidebarColumn.style.setProperty('--sidebar-left-offset', rect.left + 'px');
      }
    }

    // Update offset on resize when filters are open
    window.addEventListener('resize', function() {
      if (sidebarColumn && sidebarColumn.classList.contains('filters-active')) {
        updateSidebarOffset();
      }
    });

    // The sidebar button reads FILTERS when the menu is showing and MENU when
    // the filters panel is showing, so it always names where the click goes.
    function updateFiltersToggleLabel(filtersShowing) {
      document.querySelectorAll('.sidebar-nav__filters-label').forEach(function(label) {
        label.textContent = filtersShowing ? 'MENU' : 'FILTERS';
      });
      document.querySelectorAll('.sidebar-nav__filters-btn').forEach(function(btn) {
        btn.setAttribute('aria-label', filtersShowing ? 'Back to menu' : 'Open filters');
      });
    }

    // Toggle sidebar — inline on desktop, fixed overlay on mobile
    function openSidebar() {
      if (isMobile()) {
        sidebar.classList.add('active');
        overlay.classList.add('active');
        if (!document.body.dataset.originalOverflow) {
          document.body.dataset.originalOverflow = document.body.style.overflow || '';
        }
        document.body.style.overflow = 'hidden';
      } else {
        // If sidebar is collapsed, expand it first then open filters
        var layoutWrapper = document.querySelector('.collection-layout-with-sidebar');
        if (layoutWrapper && layoutWrapper.classList.contains('sidebar-collapsed')) {
          var tab = document.getElementById('sidebar-collapse-tab');
          if (tab) tab.click();
          setTimeout(function() {
            updateSidebarOffset();
            sidebarColumn?.classList.add('filters-active');
            updateFiltersToggleLabel(true);
          }, 550);
          return;
        }
        // Desktop: calculate offset then slide filters in from left
        updateSidebarOffset();
        sidebarColumn?.classList.add('filters-active');
        updateFiltersToggleLabel(true);
      }
    }

    function closeSidebar() {
      if (isMobile()) {
        sidebar.classList.remove('active');
        overlay.classList.remove('active');
        const originalOverflow = document.body.dataset.originalOverflow || '';
        document.body.style.overflow = originalOverflow;
        delete document.body.dataset.originalOverflow;
      } else {
        // Desktop: switch back to nav
        sidebarColumn?.classList.remove('filters-active');
        updateFiltersToggleLabel(false);
      }
    }

    toggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        // Toggle: if filters are already showing, close them
        if (!isMobile() && sidebarColumn?.classList.contains('filters-active')) {
          closeSidebar();
        } else {
          openSidebar();
        }
      });
    });
    closeBtn?.addEventListener('click', closeSidebar);
    overlay?.addEventListener('click', closeSidebar);

    // Toggle filter sections — accordion on desktop, independent toggles on mobile.
    // The .is-open class on the content is the source of truth; aria-expanded mirrors it.
    // Height strategy: animate open to the measured scrollHeight, then unlock to
    // max-height:none once the transition ends — content added later (e.g. the
    // color swatch counts, font swaps) must never be clipped. On close, pin back
    // to a pixel height first so the collapse still animates from 'none'.
    function openFilterSection(toggle, content) {
      toggle.setAttribute('aria-expanded', 'true');
      content.classList.add('is-open');
      content.style.maxHeight = content.scrollHeight + 'px';
      var onEnd = function(e) {
        if (e.target !== content || e.propertyName !== 'max-height') return;
        content.removeEventListener('transitionend', onEnd);
        if (content.classList.contains('is-open')) content.style.maxHeight = 'none';
      };
      content.addEventListener('transitionend', onEnd);
    }

    function closeFilterSection(toggle, content) {
      toggle.setAttribute('aria-expanded', 'false');
      if (content.style.maxHeight === 'none') {
        content.style.maxHeight = content.scrollHeight + 'px';
        void content.offsetHeight; // force reflow so the close transition has a start value
      }
      content.classList.remove('is-open');
      content.style.maxHeight = '';
    }

    // Sync aria-expanded to the rendered .is-open state on load; sections opened
    // by Liquid (active filters) get an unlocked height immediately.
    filterToggles.forEach(function(toggle) {
      var content = toggle.nextElementSibling;
      if (!content) return;
      var isOpen = content.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) content.style.maxHeight = 'none';
    });

    filterToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const content = this.nextElementSibling;
        if (!content) return;

        if (content.classList.contains('is-open')) {
          closeFilterSection(this, content);
        } else {
          // Accordion (one section at a time) only on desktop; on mobile the
          // drawer scrolls, so sections stay open independently.
          if (!isMobile()) {
            filterToggles.forEach(other => {
              if (other !== toggle) {
                var otherContent = other.nextElementSibling;
                if (otherContent && otherContent.classList.contains('is-open')) {
                  closeFilterSection(other, otherContent);
                }
              }
            });
          }
          openFilterSection(this, content);
        }
      });
    });

    // Dimension tabs toggle (Width / Height)
    const dimsTabs = document.querySelectorAll('.collection-filter-dims__tab');
    dimsTabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const target = this.getAttribute('data-dims-target');
        const container = this.closest('.collection-filter-dims');
        if (!container) return;

        // Update active tab
        container.querySelectorAll('.collection-filter-dims__tab').forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        // Show matching panel, hide others
        container.querySelectorAll('.collection-filter-dims__panel').forEach(panel => {
          if (panel.getAttribute('data-dims-panel') === target) {
            panel.classList.add('active');
          } else {
            panel.classList.remove('active');
          }
        });

        // Re-size the enclosing filter section to the newly visible panel
        // (only while mid-animation; once unlocked to 'none' nothing can clip)
        const sectionContent = container.closest('.collection-filter-section__content');
        if (sectionContent && sectionContent.classList.contains('is-open') && sectionContent.style.maxHeight !== 'none') {
          sectionContent.style.maxHeight = sectionContent.scrollHeight + 'px';
        }
      });
    });

    // When the viewport crosses the mobile/desktop boundary, reset both filter
    // UIs (fixed drawer vs inline slide-out) so state never leaks across modes.
    var mobileMq = window.matchMedia('(max-width: 768px)');
    function resetFilterUiOnBreakpointChange() {
      sidebar?.classList.remove('active');
      overlay?.classList.remove('active');
      document.body.style.overflow = document.body.dataset.originalOverflow || '';
      delete document.body.dataset.originalOverflow;
      sidebarColumn?.classList.remove('filters-active');
      updateFiltersToggleLabel(false);
    }
    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', resetFilterUiOnBreakpointChange);
    }

    // Client-side color palette filter with nearest-color matching
    (function() {
      const paletteFilter = document.getElementById('palette-color-filter');
      if (!paletteFilter) return;

      const swatches = paletteFilter.querySelectorAll('.collection-filter-color__swatch');
      const selectedColors = new Set();
      // PRIMARY keying = the single dominant color, so each product counts
      // toward exactly ONE swatch (honest counts). The "include secondary
      // colors" toggle widens to custom.color_list (the full bucket list).
      let currentColorSource = 'dominant_color';

      // The 20 bucket colors
      const BUCKETS = [
        '#FF0014','#FF7300','#FFFE00','#FFB800','#FF008A',
        '#7EFF2A','#00B341','#00DBFF','#0062FF','#0A1E5C',
        '#A600FF','#8B0035','#FF6B6B','#CC4E00','#E05A2B',
        '#FAF3E0','#D4B96A','#8B7355','#6E7B8B','#2B2B33'
      ];

      // Mapping of color names to hex (for dominant_color source)
      const COLOR_NAME_TO_HEX = {
        'red': '#FF0014', 'orange': '#FF7300', 'yellow': '#FFFE00',
        'gold': '#FFB800', 'pink': '#FF008A', 'hot pink': '#FF008A',
        'lime': '#7EFF2A', 'green': '#00B341', 'cyan': '#00DBFF',
        'blue': '#0062FF', 'navy': '#0A1E5C', 'violet': '#A600FF',
        'purple': '#A600FF', 'burgundy': '#8B0035', 'maroon': '#8B0035',
        'coral': '#FF6B6B', 'rust': '#CC4E00', 'terracotta': '#E05A2B',
        'cream': '#FAF3E0', 'white': '#FAF3E0', 'beige': '#FAF3E0',
        'sand': '#D4B96A', 'tan': '#D4B96A', 'taupe': '#8B7355',
        'brown': '#8B7355', 'slate': '#6E7B8B', 'gray': '#6E7B8B',
        'grey': '#6E7B8B', 'charcoal': '#2B2B33', 'black': '#2B2B33',
        'teal': '#00B341', 'magenta': '#FF008A', 'turquoise': '#00DBFF',
        'silver': '#6E7B8B', 'olive': '#8B7355', 'lavender': '#A600FF'
      };

      // Script class names for each data source
      const SOURCE_SCRIPT_CLASS = {
        'palette_hex': 'palette-data',
        'dominant_hex': 'dominant-hex-data',
        'dominant_color': 'dominant-color-data',
        'color_list': 'color-list-data'
      };

      // Hue-first bucket classifier — EXACT port of ARTVENTORY's
      // core/color_buckets.py classify_to_bucket_name(). Nearest-distance
      // matching against saturated archetypes collapses muted painting colors
      // into neutrals (forest green → Taupe); classifying by hue family with
      // a chroma gate keeps a muted green in the Green bucket. Keep the two
      // implementations in sync.
      function hexToLch(hex) {
        hex = hex.replace('#', '');
        var r = (parseInt(hex.substring(0, 2), 16) || 0) / 255;
        var g = (parseInt(hex.substring(2, 4), 16) || 0) / 255;
        var b = (parseInt(hex.substring(4, 6), 16) || 0) / 255;
        function lin(c) { return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
        var rl = lin(r), gl = lin(g), bl = lin(b);
        var x = rl * 0.4124564 + gl * 0.3575761 + bl * 0.1804375;
        var y = rl * 0.2126729 + gl * 0.7151522 + bl * 0.0721750;
        var z = rl * 0.0193339 + gl * 0.1191920 + bl * 0.9503041;
        var delta = 6 / 29;
        function f(t) { return t > delta * delta * delta ? Math.cbrt(t) : t / (3 * delta * delta) + 4 / 29; }
        var fx = f(x / 0.95047), fy = f(y / 1.0), fz = f(z / 1.08883);
        var L = 116 * fy - 16, a = 500 * (fx - fy), bb = 200 * (fy - fz);
        return { L: L, C: Math.hypot(a, bb), H: (Math.atan2(bb, a) * 180 / Math.PI + 360) % 360 };
      }

      const BUCKET_NAME_HEX = {
        'Red': '#FF0014', 'Orange': '#FF7300', 'Yellow': '#FFFE00', 'Gold': '#FFB800',
        'Hot Pink': '#FF008A', 'Lime': '#7EFF2A', 'Green': '#00B341', 'Cyan': '#00DBFF',
        'Blue': '#0062FF', 'Navy': '#0A1E5C', 'Violet': '#A600FF', 'Burgundy': '#8B0035',
        'Coral': '#FF6B6B', 'Rust': '#CC4E00', 'Terracotta': '#E05A2B', 'Cream': '#FAF3E0',
        'Sand': '#D4B96A', 'Taupe': '#8B7355', 'Slate': '#6E7B8B', 'Charcoal': '#2B2B33'
      };

      function classifyBucketName(hex) {
        const lch = hexToLch(hex);
        const L = lch.L, C = lch.C, H = lch.H;

        // Stage 1: true neutrals
        if (C < 10) {
          if (L >= 85) return 'Cream';
          if (L < 27) return 'Charcoal';
          if (H >= 40 && H <= 130 && C >= 4) return 'Taupe';
          return 'Slate';
        }

        // Stage 2: chromatic, by hue family
        if (H >= 345 || H < 5) {
          if (L < 35) return 'Burgundy';
          return 'Hot Pink';
        }
        if (H < 22) {
          if (L < 38) return 'Burgundy';
          if (L >= 58 && C < 70) return 'Coral';
          return 'Red';
        }
        if (H < 42) {
          if (L < 38) return 'Burgundy';
          if (H >= 34 && C >= 40 && C <= 80 && L < 65) return 'Terracotta';
          if (L >= 55 && C < 72) return 'Coral';
          return 'Red';
        }
        if (H < 68) {
          if (C < 25) return 'Taupe';
          if (L < 52) return 'Rust';
          if (L < 62 && C < 78) return 'Terracotta';
          return 'Orange';
        }
        if (H < 88) {
          if (C < 25) return 'Taupe';
          if (L < 55) return C < 40 ? 'Taupe' : 'Gold';
          return C >= 55 ? 'Gold' : 'Sand';
        }
        if (H < 115) {
          if (L >= 88 && C < 25) return 'Cream';
          if (L >= 80 && C >= 60) return 'Yellow';
          if (L >= 65) return 'Sand';
          return C < 35 ? 'Taupe' : 'Sand';
        }
        if (H < 136) {
          if (L >= 75 && C >= 60) return 'Lime';
          return 'Green';
        }
        if (H < 200) return 'Green';
        if (H < 252) {
          if (L < 35) return 'Navy';
          if (C < 18) return 'Slate';
          return 'Cyan';
        }
        if (H < 285) {
          if (C < 15) {
            if (L < 27) return C >= 10 ? 'Navy' : 'Charcoal';
            return 'Slate';
          }
          if (L < 28) return 'Navy';
          return 'Blue';
        }
        if (H < 308) {
          if (L < 28) return 'Navy';
          return 'Blue';
        }
        if (L < 25) return 'Navy';
        return 'Violet';
      }

      // Find the bucket hex for a raw hex color
      function nearestBucket(hex) {
        return BUCKET_NAME_HEX[classifyBucketName(hex)] || BUCKETS[0];
      }

      // Flatten any nested format into a flat array of hex strings
      function extractHexColors(data, source) {
        const out = [];
        if (!data) return out;
        if (typeof data === 'string') {
          const cleaned = data.replace(/[\\[\]"']/g, '').trim();
          // Color name handling for name-based sources (dominant_color and
          // each element of a migrated color_list array)
          if ((source === 'dominant_color' || source === 'color_list') && cleaned && !cleaned.startsWith('#') && !/^[0-9a-fA-F]{6}$/.test(cleaned)) {
            const hex = COLOR_NAME_TO_HEX[cleaned.toLowerCase()];
            if (hex) out.push(hex);
            return out;
          }
          // Split by comma, pipe, or semicolon
          cleaned.split(/[,|;]/).forEach(s => {
            const t = s.trim();
            if (t.length >= 6) out.push(t);
          });
        } else if (Array.isArray(data)) {
          data.forEach(item => {
            extractHexColors(item, source).forEach(h => out.push(h));
          });
        }
        return out;
      }

      // Map a product's raw palette to a Set of bucket colors
      function productBuckets(paletteData, source) {
        const buckets = new Set();
        if (!paletteData) return buckets;
        const colors = extractHexColors(paletteData, source);
        for (const c of colors) {
          const hex = c.startsWith('#') ? c.toUpperCase() : '#' + c.toUpperCase();
          if (hex.length === 7) buckets.add(nearestBucket(hex));
        }
        return buckets;
      }

      // Read color data from embedded <script> tag inside each card for the given source
      function getCardPalette(card, source) {
        source = source || currentColorSource;
        const className = SOURCE_SCRIPT_CLASS[source];
        if (!className) return null;
        const scriptEl = card.querySelector('script.' + className);
        if (!scriptEl) return null;
        try {
          let data = JSON.parse(scriptEl.textContent);
          // Handle double-encoding: array with a single string that is itself JSON
          if (Array.isArray(data) && data.length === 1 && typeof data[0] === 'string' && data[0].startsWith('[')) {
            try { data = JSON.parse(data[0]); } catch(e2) {}
          }
          return data;
        } catch (e) {
          // Fallback: treat as raw string
          return scriptEl.textContent;
        }
      }

      // Resolve a card's bucket set for the active source. In "include
      // secondary colors" mode we read custom.color_list — but only if the
      // desktop side has migrated it to a real list (a JSON array). While it's
      // still a semicolon blob (a plain string), fall back to dominant-only so
      // we never widen matching against half-migrated data.
      function bucketsForCard(card) {
        if (currentColorSource === 'color_list') {
          const listData = getCardPalette(card, 'color_list');
          if (Array.isArray(listData) && listData.length) {
            return productBuckets(listData, 'color_list');
          }
          return productBuckets(getCardPalette(card, 'dominant_color'), 'dominant_color');
        }
        return productBuckets(getCardPalette(card, currentColorSource), currentColorSource);
      }

      // Cache bucketed palettes on each card (recomputed when source changes)
      function cacheCardBuckets() {
        document.querySelectorAll('.collection-product-card').forEach(card => {
          if (!card._colorBuckets || card._colorSource !== currentColorSource) {
            card._colorBuckets = bucketsForCard(card);
            card._colorSource = currentColorSource;
          }
        });
      }

      // Expose for re-application after AJAX filter updates and clear-all
      window._applyPaletteColorFilter = function() {
        // Clear cache so new cards get bucketed with current source
        document.querySelectorAll('.collection-product-card').forEach(c => {
          c._colorBuckets = null;
          c._colorSource = null;
        });
        applyColorFilter();
      };
      window._paletteSelectedColors = selectedColors;

      function applyColorFilter() {
        cacheCardBuckets();
        const cards = document.querySelectorAll('.collection-product-card');
        if (selectedColors.size === 0) {
          cards.forEach(card => { card.style.display = ''; });
          updateSwatchCounts(cards);
          return;
        }
        cards.forEach(card => {
          const buckets = card._colorBuckets || new Set();
          let match = false;
          for (const color of selectedColors) {
            if (buckets.has(color)) { match = true; break; }
          }
          card.style.display = match ? '' : 'none';
        });
        updateSwatchCounts(cards);
      }

      function updateSwatchCounts(cards) {
        swatches.forEach(swatch => {
          const hex = swatch.dataset.colorHex.toUpperCase();
          let count = 0;
          cards.forEach(card => {
            const buckets = card._colorBuckets || new Set();
            if (buckets.has(hex)) count++;
          });
          const countEl = swatch.parentElement.querySelector('.collection-filter-color__count');
          if (countEl) countEl.textContent = count;
        });
      }

      // Initial count computation
      setTimeout(() => {
        cacheCardBuckets();
        updateSwatchCounts(document.querySelectorAll('.collection-product-card'));
      }, 100);

      swatches.forEach(swatch => {
        swatch.addEventListener('click', () => {
          const hex = swatch.dataset.colorHex.toUpperCase();
          const willBeActive = !swatch.classList.contains('active');

          if (willBeActive) {
            selectedColors.add(hex);
          } else {
            selectedColors.delete(hex);
          }

          swatch.classList.toggle('active', willBeActive);
          swatch.setAttribute('aria-pressed', willBeActive ? 'true' : 'false');

          // Checkmark SVG
          if (willBeActive && !swatch.querySelector('svg')) {
            const strokeColor = swatch.classList.contains('is-light') ? '#333' : 'white';
            swatch.insertAdjacentHTML('beforeend', `<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13 4L6 11L3 8" stroke="${strokeColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`);
          } else if (!willBeActive) {
            const icon = swatch.querySelector('svg');
            if (icon) icon.remove();
          }

          applyColorFilter();
        });
      });

      // Feature-detect whether custom.color_list has been migrated to a real
      // list type. A migrated value serializes to a JSON array; a legacy
      // semicolon blob serializes to a plain string. If nothing is migrated,
      // disable the secondary toggle so we stay dominant-only.
      function secondaryColorsAvailable() {
        const cards = document.querySelectorAll('.collection-product-card');
        for (const card of cards) {
          const el = card.querySelector('script.color-list-data');
          if (!el) continue;
          try {
            const d = JSON.parse(el.textContent);
            if (Array.isArray(d) && d.length) return true;
          } catch (e) {}
        }
        return false;
      }

      // "Include secondary colors" toggle: dominant-only <-> full color_list
      const secondaryToggle = document.getElementById('color-include-secondary');
      if (secondaryToggle) {
        if (!secondaryColorsAvailable()) {
          secondaryToggle.checked = false;
          secondaryToggle.disabled = true;
          const wrap = secondaryToggle.closest('.collection-filter-color__secondary');
          if (wrap) {
            wrap.classList.add('is-unavailable');
            wrap.setAttribute('title', 'Secondary colors unlock after the next inventory color sync');
          }
        }
        secondaryToggle.addEventListener('change', function() {
          currentColorSource = this.checked ? 'color_list' : 'dominant_color';
          // Invalidate all caches so cards recompute with new source
          document.querySelectorAll('.collection-product-card').forEach(c => {
            c._colorBuckets = null;
            c._colorSource = null;
          });
          cacheCardBuckets();
          const cards = document.querySelectorAll('.collection-product-card');
          if (selectedColors.size > 0) {
            applyColorFilter();
          } else {
            updateSwatchCounts(cards);
          }
        });
      }
    })();

    // Price preset handling
    const pricePresetRadios = document.querySelectorAll('input[name="price_preset"]');
    pricePresetRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (!priceMinInput || !priceMaxInput || !priceMinNumber || !priceMaxNumber) return;

        const min = Number(radio.dataset.min);
        const max = Number(radio.dataset.max);

        if (!Number.isNaN(min)) {
          priceMinInput.value = min;
          priceMinNumber.value = min;
        }

        if (!Number.isNaN(max)) {
          priceMaxInput.value = max;
          priceMaxNumber.value = max;
        }
      });
    });

    // Grid size toggle handling — use re-query to survive AJAX filter updates
    function getProductsGrid() {
      return document.querySelector('.collection-products-grid');
    }

    // Sync toolbar button active states with saved preferences
    // Called after AJAX updates that replace toolbar innerHTML
    function syncToolbarControls() {
      try {
        var savedGridSize = localStorage.getItem('collectionGridSize') || '1';
        var savedDisplayMode = localStorage.getItem('collectionDisplayMode') || 'proportional';
        document.querySelectorAll('.grid-size-toggle').forEach(function(toggle) {
          toggle.classList.toggle('active', toggle.dataset.gridSize === String(savedGridSize));
        });
        document.querySelectorAll('.display-mode-toggle').forEach(function(toggle) {
          toggle.classList.toggle('active', toggle.dataset.displayMode === savedDisplayMode);
        });
      } catch (e) {}
    }

    function setGridSize(size) {
      const grid = getProductsGrid();
      if (!grid) return;

      // Remove all grid size classes
      grid.classList.remove('grid-1', 'grid-2', 'grid-3', 'grid-5');

      // Add the selected grid size class
      grid.classList.add(`grid-${size}`);

      // Re-trigger fade animation
      reinitFadeAnimation();

      // Update active state on buttons
      document.querySelectorAll('.grid-size-toggle').forEach(toggle => {
        toggle.classList.toggle('active', toggle.dataset.gridSize === String(size));
      });

      // Save to localStorage
      try {
        localStorage.setItem('collectionGridSize', size);
      } catch (e) {
        console.error('Failed to save grid size preference:', e);
      }
    }

    // Use event delegation on document so listeners survive toolbar innerHTML replacement
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('.grid-size-toggle');
      if (toggle) {
        setGridSize(toggle.dataset.gridSize);
      }
    });

    // Hover image swap via delegation on document
    document.addEventListener('mouseenter', (e) => {
      const toggle = e.target.closest('.grid-size-toggle');
      if (toggle) {
        const img = toggle.querySelector('img');
        if (img && toggle.dataset.hover) img.src = toggle.dataset.hover;
      }
    }, true);
    document.addEventListener('mouseleave', (e) => {
      const toggle = e.target.closest('.grid-size-toggle');
      if (toggle) {
        const img = toggle.querySelector('img');
        if (img && toggle.dataset.icon) img.src = toggle.dataset.icon;
      }
    }, true);

    // Display mode toggle handling
    function setDisplayMode(mode) {
      const grid = getProductsGrid();
      if (!grid) return;

      // Remove existing display mode classes
      grid.classList.remove('display-proportional', 'display-square');

      // Add the selected display mode class
      grid.classList.add(`display-${mode}`);

      // Re-trigger fade animation
      reinitFadeAnimation();

      // Update active state on buttons
      document.querySelectorAll('.display-mode-toggle').forEach(toggle => {
        toggle.classList.toggle('active', toggle.dataset.displayMode === mode);
      });

      // Save to localStorage
      try {
        localStorage.setItem('collectionDisplayMode', mode);
      } catch (e) {
        console.error('Failed to save display mode preference:', e);
      }
    }

    // Use event delegation on document so listeners survive toolbar innerHTML replacement
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('.display-mode-toggle');
      if (toggle) {
        setDisplayMode(toggle.dataset.displayMode);
      }
    });

    // Load saved display mode preference on page load
    try {
      const savedDisplayMode = localStorage.getItem('collectionDisplayMode');
      if (savedDisplayMode && (savedDisplayMode === 'proportional' || savedDisplayMode === 'square')) {
        setDisplayMode(savedDisplayMode);
      } else {
        // Default to proportional
        setDisplayMode('proportional');
      }
    } catch (e) {
      console.error('Failed to load display mode preference:', e);
      setDisplayMode('proportional');
    }

    // Load saved grid size preference on page load
    try {
      const savedGridSize = localStorage.getItem('collectionGridSize');
      if (savedGridSize) {
        setGridSize(savedGridSize);
      } else {
        // Default to masonry (matching homepage featured grid)
        setGridSize('1');
      }
    } catch (e) {
      console.error('Failed to load grid size preference:', e);
      // Default to masonry if localStorage fails
      setGridSize('1');
    }

    // Debounced resize handler for filter sidebar
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // Recalculate heights if sidebar is open
        if (sidebar && sidebar.classList.contains('active')) {
          const formContent = document.querySelector('.collection-filters-form__content');
          if (formContent) {
            // Force reflow to recalculate scrollable areas
            formContent.style.maxHeight = 'none';
            requestAnimationFrame(() => {
              formContent.style.maxHeight = '';
            });
          }
          
          // Recalculate expanded filter sections
          filterToggles.forEach(toggle => {
            if (toggle.getAttribute('aria-expanded') === 'true') {
              const content = toggle.nextElementSibling;
              if (content && content.classList.contains('is-open')) {
                // Force reflow for proper height calculation
                content.style.maxHeight = 'none';
                requestAnimationFrame(() => {
                  content.style.maxHeight = '';
                });
              }
            }
          });
        }
      }, 150); // 150ms debounce
    };

    window.addEventListener('resize', handleResize);

    // Handle orientation change specifically
    window.addEventListener('orientationchange', () => {
      setTimeout(handleResize, 100);
    });

    // === Scroll Fade-In Animation ===
    // Global observer reference for cleanup
    window.fadeObserver = null;
    // Track which cards have been revealed to prevent re-animation
    window.revealedCards = new WeakSet();

    function getColumnCount() {
      const grid = document.querySelector('.collection-products-grid');
      if (!grid) return 3;
      return getComputedStyle(grid).gridTemplateColumns.split(' ').length || 3;
    }

    function reinitFadeAnimation() {
      const productCards = document.querySelectorAll('.collection-product-card');
      if (!productCards.length) return;

      // Disconnect old observer first
      if (window.fadeObserver) {
        window.fadeObserver.disconnect();
        window.fadeObserver = null;
      }

      // Reset all cards for fresh animation
      productCards.forEach(card => {
        card.classList.remove('fade-ready', 'revealed');
        card.style.transitionDelay = '';
      });

      // Wait for layout to settle
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const columns = getColumnCount();

          // Track which rows have been triggered so we reveal entire rows together
          const revealedRows = new Set();

          // Create observer that reveals full rows left-to-right
          window.fadeObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const card = entry.target;
                const allCards = Array.from(document.querySelectorAll('.collection-product-card'));
                const cardIndex = allCards.indexOf(card);
                const currentColumns = getColumnCount();
                const rowIndex = Math.floor(cardIndex / currentColumns);

                // Only process each row once
                if (revealedRows.has(rowIndex)) {
                  window.fadeObserver.unobserve(card);
                  return;
                }
                revealedRows.add(rowIndex);

                // Reveal all cards in this row with left-to-right stagger
                const rowStart = rowIndex * currentColumns;
                const rowEnd = Math.min(rowStart + currentColumns, allCards.length);
                for (let i = rowStart; i < rowEnd; i++) {
                  const rowCard = allCards[i];
                  const posInRow = i - rowStart;
                  rowCard.style.transitionDelay = `${posInRow * 0.12}s`;
                  rowCard.classList.add('revealed');
                  window.fadeObserver.unobserve(rowCard);
                }
              }
            });
          }, {
            threshold: 0.05,
            rootMargin: '0px 0px 250px 0px'
          });

          // Set up all cards
          productCards.forEach((card, index) => {
            const positionInRow = index % columns;
            const rowIndex = Math.floor(index / columns);
            const rect = card.getBoundingClientRect();
            const isAboveFold = rect.top < window.innerHeight;

            // Add fade-ready to enable CSS transition
            card.classList.add('fade-ready');

            if (isAboveFold) {
              // Cards above fold: reveal with sequential left-to-right stagger
              card.style.transitionDelay = `${0.1 + (positionInRow * 0.12)}s`;
              revealedRows.add(rowIndex);
              requestAnimationFrame(() => {
                card.classList.add('revealed');
              });
            } else {
              // Cards below fold: observe for scroll reveal
              window.fadeObserver.observe(card);
            }
          });
        });
      });
    }

    // === Orientation Detection for PHI-Based Spacing ===
    function applyOrientationClasses() {
      const cards = document.querySelectorAll('.collection-product-card');
      cards.forEach(card => {
        const img = card.querySelector('.collection-product-card__image');
        if (!img) return;

        // Remove existing orientation classes
        card.classList.remove('orientation-vertical', 'orientation-horizontal', 'orientation-square');

        // Wait for image to load if needed
        const checkOrientation = () => {
          const width = img.naturalWidth || img.width;
          const height = img.naturalHeight || img.height;

          if (width && height) {
            const ratio = width / height;
            // PHI-based thresholds: square is within 0.85-1.15 ratio range
            if (ratio < 0.85) {
              card.classList.add('orientation-vertical');
            } else if (ratio > 1.15) {
              card.classList.add('orientation-horizontal');
            } else {
              card.classList.add('orientation-square');
            }
          }
        };

        if (img.complete) {
          checkOrientation();
        } else {
          img.addEventListener('load', checkOrientation, { once: true });
        }
      });
    }

    // Expose globally for AJAX collection switching from sidebar nav
    window.reinitFadeAnimation = reinitFadeAnimation;
    window.applyOrientationClasses = applyOrientationClasses;
    window.syncToolbarControls = syncToolbarControls;

    // Initialize on page load
    document.addEventListener('DOMContentLoaded', function() {
      reinitFadeAnimation();
      applyOrientationClasses();
    });

    // AJAX Filtering
    const filterForm = document.querySelector('.collection-filters-form');
    if (filterForm) {
      var currentAbortController = null;
      var liveDebounceTimer = null;

      function buildFilterUrl() {
        var formData = new FormData(filterForm);
        var params = new URLSearchParams();
        for (var pair of formData.entries()) {
          if (pair[1] !== '' && pair[0] !== 'price_preset') {
            params.append(pair[0], pair[1]);
          }
        }
        return filterForm.action + (params.toString() ? '?' + params.toString() : '');
      }

      function fetchFiltered(opts) {
        var shouldCloseSidebar = opts && opts.closeSidebar;
        var shouldScrollToTop = opts && opts.closeSidebar;

        // Abort any in-flight request
        if (currentAbortController) {
          currentAbortController.abort();
        }
        currentAbortController = new AbortController();

        var url = buildFilterUrl();
        var productsContainer = document.querySelector('.collection-products');

        // Slide out the current grid
        if (productsContainer) {
          productsContainer.classList.add('slide-out');
        }

        // Pin scroll: calculate target before fetch so we can scroll smoothly
        var collectionContent = document.getElementById('collection-content');
        var currentScroll = window.scrollY;
        var contentTop = collectionContent
          ? collectionContent.getBoundingClientRect().top + window.scrollY - 60
          : 0;
        // Scroll if we're meaningfully away from the content area (either direction)
        var needsScroll = shouldScrollToTop && Math.abs(currentScroll - contentTop) > 100;

        fetch(url, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: currentAbortController.signal
        })
          .then(function(response) {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
          })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            // Update product grid + pagination
            var newProducts = doc.querySelector('.collection-products');
            if (newProducts && productsContainer) {
              productsContainer.innerHTML = newProducts.innerHTML;
              productsContainer.classList.remove('slide-out');

              // Set up slide-in: start off-screen right
              productsContainer.classList.add('slide-in');
              productsContainer.style.pointerEvents = 'none';

              // Re-apply display mode and grid size to new grid element
              var newGrid = productsContainer.querySelector('.collection-products-grid');
              if (newGrid) {
                try {
                  var savedDisplayMode = localStorage.getItem('collectionDisplayMode') || 'proportional';
                  var savedGridSize = localStorage.getItem('collectionGridSize') || '1';
                  newGrid.classList.add('display-' + savedDisplayMode, 'grid-' + savedGridSize);
                } catch (e) {
                  newGrid.classList.add('display-proportional', 'grid-1');
                }
              }

              // Clear revealed cards tracking for fresh content
              window.revealedCards = new WeakSet();
              // Apply orientation classes for PHI-based spacing
              applyOrientationClasses();
              // Re-apply client-side color filter to new product cards
              if (window._applyPaletteColorFilter) window._applyPaletteColorFilter();

              // Slide in after a frame so the browser registers the starting position
              requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                  productsContainer.classList.remove('slide-in');
                  productsContainer.classList.add('slide-in-active');
                  productsContainer.style.pointerEvents = '';

                  // Re-initialize fade-in animation for new products (starts sequential reveal)
                  reinitFadeAnimation();

                  // Clean up transition classes after animation completes
                  setTimeout(function() {
                    productsContainer.classList.remove('slide-in-active');
                  }, 400);
                });
              });
            }

            // Update product count in toolbar center
            var countCenter = document.querySelector('.collection-toolbar__center');
            var newCountCenter = doc.querySelector('.collection-toolbar__center');
            if (countCenter && newCountCenter) {
              countCenter.innerHTML = newCountCenter.innerHTML;
            }

            // Update active filters row
            var existingFiltersRow = document.querySelector('.collection-active-filters-row');
            var newFiltersRow = doc.querySelector('.collection-active-filters-row');
            if (existingFiltersRow && newFiltersRow) {
              existingFiltersRow.replaceWith(newFiltersRow);
            } else if (existingFiltersRow && !newFiltersRow) {
              existingFiltersRow.remove();
            } else if (!existingFiltersRow && newFiltersRow) {
              var toolbar = document.querySelector('.collection-toolbar');
              if (toolbar) {
                toolbar.after(newFiltersRow);
              }
            }

            // Update filter toggle badge
            var existingToggle = document.querySelector('.collection-filters-toggle');
            var newToggle = doc.querySelector('.collection-filters-toggle');
            if (existingToggle && newToggle) {
              existingToggle.innerHTML = newToggle.innerHTML;
            }

            // Update URL
            history.pushState({}, '', url);

            // Scroll to content area if meaningfully away (either direction)
            if (needsScroll) {
              if (window.lenisInstance) {
                window.lenisInstance.scrollTo(contentTop, { duration: 1.2 });
              } else {
                window.scrollTo({ top: contentTop, behavior: 'smooth' });
              }
            }

            if (shouldCloseSidebar) {
              closeSidebar();
            }

            currentAbortController = null;
          })
          .catch(function(err) {
            if (err.name === 'AbortError') return; // Superseded by newer request
            // Fallback: restore state
            if (productsContainer) {
              productsContainer.classList.remove('slide-out', 'slide-in', 'slide-in-active');
              productsContainer.style.pointerEvents = '';
            }
            // On explicit submit, fall back to normal form submit
            if (shouldCloseSidebar) {
              filterForm.submit();
            }
          });
      }

      // Explicit "Apply Filters" submit — close sidebar + scroll
      filterForm.addEventListener('submit', function(e) {
        e.preventDefault();
        clearTimeout(liveDebounceTimer);
        fetchFiltered({ closeSidebar: true });
      });

      // Live update on any filter change (debounced, sidebar stays open)
      filterForm.addEventListener('change', function(e) {
        // Skip price_preset radios — they only set range values, not a real filter
        if (e.target.name === 'price_preset') return;
        clearTimeout(liveDebounceTimer);
        liveDebounceTimer = setTimeout(function() {
          fetchFiltered({ closeSidebar: false });
        }, 350);
      });

      // Clear All handler
      var clearBtn = document.getElementById('clear-all-filters');
      if (clearBtn) {
        clearBtn.addEventListener('click', function() {
          filterForm.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function(input) {
            input.checked = false;
          });
          filterForm.querySelectorAll('.collection-filter-color__swatch').forEach(function(swatch) {
            swatch.classList.remove('active');
            swatch.setAttribute('aria-pressed', 'false');
            var svg = swatch.querySelector('svg');
            if (svg) svg.remove();
          });
          // Reset client-side palette color filter
          if (window._paletteSelectedColors) window._paletteSelectedColors.clear();
          document.querySelectorAll('.collection-product-card').forEach(function(card) {
            card.style.display = '';
          });
          var priceMinRange = filterForm.querySelector('[data-role="price-min"]');
          var priceMaxRange = filterForm.querySelector('[data-role="price-max"]');
          var priceMinInput = filterForm.querySelector('#filter-price-min-input');
          var priceMaxInput = filterForm.querySelector('#filter-price-max-input');
          if (priceMinRange) {
            priceMinRange.value = priceMinRange.min;
            if (priceMinInput) priceMinInput.value = priceMinRange.min;
          }
          if (priceMaxRange) {
            priceMaxRange.value = priceMaxRange.max;
            if (priceMaxInput) priceMaxInput.value = priceMaxRange.max;
          }
          clearTimeout(liveDebounceTimer);
          fetchFiltered({ closeSidebar: false });
        });
      }
    }

    // Handle popstate (browser back/forward) for AJAX filtered pages
    window.addEventListener('popstate', function() {
      location.reload();
    });

    // Scroll-to-top button
    (function() {
      var scrollBtn = document.querySelector('.collection-scroll-top');
      if (!scrollBtn) return;

      var showThreshold = 400;

      function onScroll() {
        if (window.scrollY > showThreshold) {
          scrollBtn.classList.add('is-visible');
        } else {
          scrollBtn.classList.remove('is-visible');
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      scrollBtn.addEventListener('click', function() {
        if (window.lenisInstance) {
          window.lenisInstance.scrollTo(0, { duration: 1.2 });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    })();

  })();
